import { IApplicationContext } from 'shared/types/applicationContext';
import { createReferralReduxStore } from 'shared/utils/redux';
import { TApplicationState, TReduxStore } from '../../../shared/types/referral/store';

export function createReferralApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<TApplicationState>('initialState');

  return createReferralReduxStore(context, initialState, true);
}
